import colors from "vuetify/es5/util/colors";
import { ThemeOptions } from "vuetify/types/services/theme";

export const centralcoopTheme: ThemeOptions = {
  themes: {
    light: {
      primary: "#445237",
      secondary: "#82BC00",
      accent: colors.lime.base,
      error: colors.pink.base,
      warning: colors.yellow.base,
      info: colors.blue.base,
      success: colors.lightGreen.base,
    },
  },
};
